// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__JPypG","sidebarmain":"SideBar_sidebarmain__KGcAb","sectionAccordionWrapper":"SideBar_sectionAccordionWrapper__wU0ek"};